import { render, staticRenderFns } from "./DashboardWidgetArea.vue?vue&type=template&id=5ab7dab7&scoped=true&"
import script from "./DashboardWidgetArea.vue?vue&type=script&lang=ts&"
export * from "./DashboardWidgetArea.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardWidgetArea.vue?vue&type=style&index=0&id=5ab7dab7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7dab7",
  null
  
)

export default component.exports